import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/page/dashboard/index'
import SendLog from '@/page/send-log/index'
import NotAuthorized from '@/page/not-authorized/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/send-log',
      name: 'SendLog',
      component: SendLog
    },
    {
      path: '/not-authorized',
      name: 'NotAuthorized',
      component: NotAuthorized
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js